var _circle, _path, _path2, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 28,
    fill: "#FBE5E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 16 L42 36 L20 36 Z",
    fill: "none",
    stroke: "#E65267",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 24v6",
    stroke: "#E65267",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 33,
    r: 1.5,
    fill: "#E65267"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveAlertIcon);
export default __webpack_public_path__ + "static/media/remove-alert-icon.81270e97e337bf02e19e8cdcf10d0f19.svg";
export { ForwardRef as ReactComponent };